<template>
  <div id="workflowComponent">
    <template>
      <div class="page-title" style="display: flex; align-items: center; justify-content: space-between;">
        <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
          <v-layout row wrap class="mb-2" align-center>
             <v-spacer></v-spacer>
            <v-flex xs6>
              <v-text-field v-model="searchWorkflows" :disabled="!workflows.length > 0" :label="$t('general.search')" color="light" clearable append-outer-icon="search"></v-text-field>
            </v-flex>
              <v-btn :disabled="!workflows.length > 0  || loadingExcelReport" slot="activator" color="primary" @click="downloadReport" round outline>
                <v-icon left>download</v-icon>
                {{ $t('general.downloadReport') }}
              </v-btn>
          </v-layout>
      </div>
    </template>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs4 v-for="item in workflowsFilterBySearch" :key="item.id">
          <v-card min-height="200px">
           <v-toolbar color="primary" class="text-white" flat>
            <v-layout row wrap align-center>
              <v-flex xs11>
                <h3 class="font-weight-black  mb-0">{{ $t('workflow.name') }}: {{ item.name }}</h3>
              </v-flex>
              <v-flex class="text-right" xs1>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click="chooseApprover(item)" class="ml-auto white--text">
                      <v-icon>manage_accounts</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('workflow.addApprover') }}</span>
                </v-tooltip>
              </v-flex>
              <v-flex style="margin-top: -15px;" xs12>
                <h3 class="font-weight-black ">{{ $t('approver.name') }}: {{ getApprover(item) }}</h3>
              </v-flex>
            </v-layout>
          </v-toolbar>
            <v-timeline dense>
              <v-timeline-item
                v-for="validator in item.items" :key="validator.id"
                small
                color="primary"
                icon="arrow_downward"
                fill-dot>
              <v-card flat class="grey lighten-2 mr-2">
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs10>
                      <v-layout>
                        <p class="font-weight-bold mb-0">{{ validator.validator.user.name }}</p>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <span class="font-weight-bold mb-0">{{ item.items.indexOf(validator) + 1}}.- "{{validator.name}}"</span>
                        </v-flex>
                        <v-flex xs12>
                          <span>{{validator.description}}</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs2>
                      <v-layout fill-height align-center>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" @click="showWorkflowDialog(validator)"><v-icon>visibility</v-icon></v-btn>
                          </template>
                          <span>{{ $t('general.seeMore') }}</span>
                        </v-tooltip>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              </v-timeline-item>
            </v-timeline>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" block color="primary" @click="createItem(item)"><v-icon>add</v-icon></v-btn>
              </template>
              <span>{{ $t('workflow.addValidator') }}</span>
            </v-tooltip>
          </v-card>
        </v-flex>
        <v-flex xs4>
          <v-card color="grey lighten-4" height="200px">
            <v-layout row fill-height align-center justify-center>
              <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon @click="createWorkflow"><v-icon>add</v-icon></v-btn>
              </template>
              <span>{{ $t('workflow.add') }}</span>
            </v-tooltip>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog persistent v-model="itemWorkflowDialog" max-width="600px">
        <v-card>
          <v-toolbar flat >
            <h2 class="font-weight-black primary--text mb-0">{{ $t('workflow.addValidatorIn', {area: workflow.name}) }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <v-container>
              <v-form
                lazy-validation
                ref="formItem"
                v-model="validItem"
              >
                <v-text-field
                  clearable
                  required
                  :rules="rules.textRules"
                  :label="$t('workflow.workflowName')"
                  v-model="editedItem.name"
                  :error-messages="errors.name"
                >
                </v-text-field>
                <v-layout>
                  <v-flex xs6>
                    <!-- Validator -->
                    <v-autocomplete
                      class="mr-3"
                      v-model="editedItem.gst_validator_id"
                      :rules="rules.required"
                      :items="validatorFilter"
                      item-text="user.name"
                      item-value="id"
                      :label="$t('validator.name')"
                      :error-messages="errors.gst_validators_id"
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      v-model="editedItem.gst_substitute_id"
                      :items="substitutes"
                      item-text="user.name"
                      item-value="id"
                      :label="$t('workflow.substitute') + ' (' + $t('general.optional') + ')'"
                      :error-messages="errors.gst_substitute_id"
                    >
                    </v-select>
                  </v-flex>
                </v-layout>
                <v-text-field
                  clearable
                  :rules="rules.textNoReq"
                  :label="$t('general.description')"
                  v-model="editedItem.description"
                  :error-messages="errors.description"
                >
                </v-text-field>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              round
              flat
              @click="closeItem"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading || validExist"
              color="primary"
              round
              depressed
              @click="saveItem"
            >
              {{ $t('general.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="workflowDialog" max-width="600px">
        <v-card>
          <v-toolbar flat >
            <h2 class="font-weight-black primary--text mb-0">{{ $t('workflow.add') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <h2 class="primary--text">{{ $t('workflow.element') }}</h2>
            <v-container>
              <v-form
                lazy-validation
                ref="formWorkflow"
                v-model="validWorkflow"
              >
                <v-layout>
                  <v-flex xs6>
                    <v-text-field
                      class="mr-3"
                      clearable
                      required
                      :rules="rules.textRules"
                      :label="$t('workflow.workflowName')"
                      v-model="editedItem.name"
                      :error-messages="errors.name"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      v-model="editedItem.gst_area"
                      :rules="rules.required"
                      :items="areasFilter"
                      item-text="name"
                      item-value="id"
                      :label="$t('validator.selectArea')"
                      :error-messages="errors.name"
                    >
                    </v-select>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs6>
                    <v-autocomplete
                      class="mr-3"
                      v-model="editedItem.gst_validator_id"
                      :rules="rules.required"
                      :items="validatorFilter3"
                      item-text="user.name"
                      item-value="id"
                      :label="$t('validator.assign')"
                      :error-messages="errors.gst_validator_id"
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      v-model="editedItem.gst_substitute_id"
                      :items="substitutes"
                      item-text="user.name"
                      item-value="id"
                      :label="$t('workflow.substitute') + ' (' + $t('general.optional') + ')'"
                      :error-messages="errors.gst_substitute_id"
                    >
                    </v-select>
                  </v-flex>
                </v-layout>
                <v-text-field
                  clearable
                  required
                  :rules="rules.textNoReq"
                  :label="$t('general.description')"
                  :error-messages="errors.description"
                  v-model="editedItem.description"
                >
                </v-text-field>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              round
              flat
              @click="closeWorkflow"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading || validExist"
              color="primary"
              round
              depressed
              @click="saveWorkflow"
            >
              {{ $t('general.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="viewWorkflowDialog" width="600px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{ $t('workflow.description') }}</h2>
          </v-toolbar>
          <v-card-text>
            <v-container class="text-sm-justify">
              <v-layout>
                <v-flex xs6>
                  <h3 class="font-weight-bold">{{ $t('workflow.workflowName') }}: </h3>
                  <p>{{viewWorkflow.name}}</p>
                </v-flex>
                <v-flex xs6>
                  <h3 class="font-weight-bold">{{ $t('area.name') }}: </h3>
                  <p>{{viewWorkflow.area.name}}</p>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs6>
                  <h3 class="font-weight-bold">{{ $t('validator.name') }}:</h3>
                  <p>{{viewWorkflow.validator.user.name}}</p>
                </v-flex>
                <v-flex xs6>
                  <h3 class="font-weight-bold">{{ $t('workflow.substitute')}}</h3>
                  <p>{{viewWorkflow.substitutes.user.name}}</p>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs6>
                  <h3 class="font-weight-bold">{{ $t('general.description') }}:</h3>
                  <p>{{viewWorkflow.description}}</p>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat round color="primary" @click="closeViewWorkflow">{{ $t('general.cancel') }}</v-btn>
            <v-btn outline round color="primary" @click="editItemWorkflow(viewWorkflow)">{{ $t('general.edit') }}</v-btn>
            <v-btn disabled outline round color="primary" @click="editPlace(viewWorkflow)">{{ $t('workflow.changePlace') }}</v-btn>
            <v-btn outline round color="error" @click="removeItem(viewWorkflow)">{{ $t('general.delete') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="editWorkflowDialog" width="600px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{ $t('general.edit') }}</h2>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form
                lazy-validation
                ref="formEditItem"
                v-model="validEdit"
              >
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      :label="$t('workflow.workflowName')"
                      v-model="editedViewItem.name"
                      required
                      :rules="rules.textRules"
                      :error-messages="errors.name"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      :label="$t('general.description')"
                      v-model="editedViewItem.description"
                      required
                      :rules="rules.textNoReq"
                      :error-messages="errors.description"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      class="mr-3"
                      v-model="editedViewItem.gst_validators_id"
                      :rules="rules.required"
                      :items="validatorFilter2"
                      item-text="user.name"
                      item-value="id"
                      :label="$t('validator.name')"
                      :error-messages="errors.gst_validators_id"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      :label="$t('workflow.substitute') + '(' + $t('general.optional') + ')'"
                      v-model="editedViewItem.gst_substitute_id"
                      :items="substitutes"
                      item-text="user.name"
                      item-value="id"
                      :error-messages="errors.gst_substitute_id"
                    >
                    </v-select>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn round flat color="primary" @click="closeEditWorkflow">{{ $t('general.close') }}</v-btn>
            <v-btn :loading="loading" round depressed color="primary" @click="saveEditedItem">{{ $t('general.save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="editPlaceDialog" width="700px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{ $t('workflow.changePlace') }}</h2>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-chip color="primary" dark><h3>{{$t('workflow.workflowPosition')}}</h3></v-chip>
                  <v-data-table hide-actions hide-headers :items="placeOptions">
                    <template v-slot:items="props">
                      <tr>
                        <td>{{$t('workflow.step')}} {{props.index + 1}}</td>
                        <td>{{props.item.name}}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
                  <v-flex xs6>
                    <v-form
                      lazy-validation
                      ref="formPlace"
                      v-model="validPlace"
                    >
                      <v-layout row wrap>
                          <v-flex xs12>
                            <v-text-field disabled :label="$t('workflow.workflowName')" v-model="editedPlaceItem.name"></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-select
                              required
                              :rules="rules.required"
                              :items="placeOptions"
                              item-text="name"
                              v-model="editedPlaceItem.to"
                              item-value="id"
                              :label="$t('workflow.replaceValidator')"
                            >
                            </v-select>
                          </v-flex>
                      </v-layout>
                    </v-form>
                  </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn round flat color="primary" @click="closeEditPlace">{{ $t('general.close') }}</v-btn>
            <v-btn :loading="loading" round depressed color="primary" @click="changePlace()">{{ $t('general.save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="removeDialog" max-width="500px">
        <v-card>
          <v-toolbar flat >
            <h2 class="font-weight-black error--text mb-0">{{ $t('general.deleteElement') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
            <p class="font-weight-black"><span class="error--text">{{ $t('workflow.step') }}: </span>{{removedItem.name}}</p>
            <p class="font-weight-black"><span class="error--text">{{ $t('area.name') }}: </span>{{removedItem.area.name}}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              color="error"
              round
              depressed
              @click="remove(removedItem)"
            >
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="chooseApproverDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{ $t('approver.select') }}</h2>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form
                lazy-validation
                ref="formEditApprover"
                v-model="validUpdateApprover">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-select
                      class="mr-3"
                      v-model="editApprover.gst_approver_id"
                      :rules="rules.required"
                      :items="filterApprovers"
                      item-text="users[0].name"
                      item-value="id"
                      :label="$t('approver.name')"
                      :error-messages="errors.gst_approver_id">
                    </v-select>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn round flat color="primary" @click="chooseApproverDialog = false">{{ $t('general.close') }}</v-btn>
            <v-btn :loading="loading" round depressed color="primary" @click="updateApprover">{{ $t('general.save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'workflowComponent',
  data () {
    return {
      searchWorkflows: '',
      userLogged: {},
      editApprover: {},
      workflows: [],
      substitutes: [],
      filterWorkflows: [],
      group: [],
      validators: [],
      approvers: [],
      placeOptions: [],
      areas: [],
      validExist: false,
      loading: false,
      disabled: false,
      errors: {},
      workflowDialog: false,
      itemWorkflowDialog: false,
      viewWorkflowDialog: false,
      editWorkflowDialog: false,
      chooseApproverDialog: false,
      editPlaceDialog: false,
      removeDialog: false,
      validItem: true,
      validWorkflow: true,
      validEdit: true,
      validUpdateApprover: true,
      validPlace: true,
      viewWorkflow: {
        area: {
          name: ''
        },
        validator: {
          user: {
            name: ''
          }
        },
        substitutes: {
          user: {
            name: ''
          }
        }
      },
      workflow: {
        area: {
          name: ''
        }
      },
      removedItem: {
        area: {
          name: ''
        }
      },
      editedWorkflow: {
        id: 0,
        name: '',
        data: []
      },
      defaultWorkflow: {
        id: 0,
        name: '',
        data: []
      },
      editedViewItem: {
        name: '',
        description: '',
        validator: {
          user: {
            name: ''
          },
          status: 0
        },
        substitute: {
          user: {
            name: ''
          }
        }
      },
      editedPlaceItem: {
        validator: {
          user: {
            name: ''
          }
        }
      },
      editedItemId: -1,
      editedItem: {
        id: 0,
        name: '',
        gst_validator_id: 0,
        next_step: 0,
        gst_substitute_id: '',
        gst_area: 0,
        description: '',
        is_approval_step: 0,
        is_first_step: 0,
        status_validator: 0
      },
      defaultItem: {
        id: 0,
        name: '',
        gst_validator_id: 0,
        next_step: 0,
        gst_substitute_id: '',
        gst_area: 0,
        description: '',
        is_approval_step: 0,
        is_first_step: 0
      },
      loadingExcelReport: false,
    }
  },
  computed: {
    heading () {
      return this.$t('workflow.name')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fas fa-project-diagram fa-fw icon-color'
    },
    rules () {
      return this.$validationRules()
    },
    areaValidators () {
      return this.validators.filter(item => item.gst_area_id === this.editedPlaceItem.gst_area_id)
    },
    areasFilter () {
      if (this.userLogged.company) {
        return this.areas.filter(item => item.company_id === this.userLogged.company[0].id)
      }
    },
    validatorFilter () {
      const validatorsByArea = this.validators.filter(item => item.gst_area_id === this.workflow.gst_area_id && item.user.active === 1)
      
      return this.getValidators(validatorsByArea)
    },
    validatorFilter2 () {
      const validatorsByArea = this.validators.filter(item => item.gst_area_id === this.editedViewItem.gst_area_id && item.user.active === 1)

      return this.getValidators(validatorsByArea)
    },
    validatorFilter3 () {
      const validatorsByArea = this.validators.filter(item => item.gst_area_id === this.editedItem.gst_area && item.user.active === 1)
      
      return this.getValidators(validatorsByArea)
    },
    companyValidators () {
      return this.validators.filter(item => item.area.company_id === this.userLogged.company[0].id)
    },
    filterApprovers () {
      return this.approvers.filter(item => item.users[0].company[0].id === this.userLogged.company[0].id && item.users[0].active === 1)
    },
    workflowsFilterBySearch() {
      const term = this.searchWorkflows.trim().toLowerCase()

      if (!term) return this.workflows
      
      let workflowFiltered = this.workflows
        .map(workflow => {
              const filteredItems = workflow.items.filter(item => {
                const itemName = workflow.name ? workflow.name.toLowerCase() : ''
                const validatorName = item && item.validator && item.validator.user && item.validator.user.name 
                                    ? item.validator.user.name.toLowerCase() 
                                    : ''
                return itemName.includes(term) || validatorName.includes(term)
              })

            const workflowMatches = workflow && workflow.name && workflow.name.toLowerCase().includes(term);
          
            if (workflowMatches || filteredItems.length > 0) return workflow


            return null;
        })
        .filter(Boolean)
        
        return workflowFiltered;
    }
  },
  created () {
    this.initialize()
    this.getLogged()
  },
  watch: {
    dialog (val) {
      val || this.closeItem()
    },
    userLogged () {
      this.$emit('getSubstitutes', {id: this.userLogged.company[0].id, context: this})
    },
    '$store.state.userLogged': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getLogged()
      }
    },
    'editedItem.gst_validator_id' () {
      if (this.workflow.items && this.workflow.items.find(item => item.gst_validators_id === this.editedItem.gst_validator_id)) {
        this.validExist = true
        this.errors.gst_validators_id = this.$t('workflow.validatorExist')
        this.errors.gst_validator_id = this.$t('workflow.validatorExist')
      } else {
        this.validExist = false
        this.errors.gst_validators_id = ''
        this.errors.gst_validator_id = ''
      }
    },
    'editedItem.gst_area' () {
      if (this.workflows.find(item => item.gst_area_id === this.editedItem.gst_area)) {
        this.workflow = this.workflows.find(item => item.gst_area_id === this.editedItem.gst_area)
      }
    }
  },
  methods: {
    downloadReport() {
      this.loadingExcelReport = true
      this.$emit('downloadReport', {
        context: this,
      })
    },
    getValidators (validators) {
      return validators.filter(validator => {
        const userId = validator.user.id;
        const existsInWorkflow = this.workflow.items ? this.workflow.items.some(wf => wf.validator && wf.validator.user && wf.validator.user.id === userId ) : false
        return !existsInWorkflow;
      })
    },
    getApprover (item) {
      const itemApprover = item.items.find(item => item.is_first_step === 1)

      const approver = this.filterApprovers.find(approver => approver.id === itemApprover.gst_approver_id)
      
      return approver ? approver.users[0].name : this.$t('workflow.noSubstitute')
    },
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
        this.getWorkflows()
      }
    },
    initialize () {
      this.$emit('elementsGet', {context: this})
    },
    getWorkflows () {
      this.$emit('getWorkflows', {id: this.userLogged.company[0].id, context: this})
    },
    createItem (item) {
      this.workflow = item
      this.itemWorkflowDialog = true
    },
    createWorkflow () {
      this.workflowDialog = true
    },
    editItemWorkflow (item) {
      this.editWorkflowDialog = true
      this.editedViewItem = Object.assign({}, item)
    },
    editPlace (item) {
      this.editedPlaceItem = item
      this.$emit('areaWorkflows', {area: item.gst_area_id, context: this})
    },
    closeItem () {
      this.itemWorkflowDialog = false
      this.workflow = {area: {name: ''}}
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedItemId = -1
      this.$refs.formItem.resetValidation()
      this.errors = {}
    },
    closeWorkflow () {
      this.workflowDialog = false
      this.editedWorkflow = Object.assign({}, this.defaultWorkflow)
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedItemId = -1
      this.$refs.formWorkflow.resetValidation()
      this.errors = {}
    },
    closeViewApprove () {
      this.chooseApproverDialog = false
      this.editApprover = Object.assign({}, this.defaultWorkflow)
      this.$refs.formEditApprover.resetValidation()
      this.errors = {}
    },
    closeEditPlace () {
      this.editPlaceDialog = false
      this.$refs.formPlace.resetValidation()
      this.errors = {}
    },
    closeViewWorkflow () {
      this.viewWorkflowDialog = false
      this.errors = {}
    },
    closeEditWorkflow () {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editWorkflowDialog = false
      this.$refs.formEditItem.resetValidation()
      this.errors = {}
    },
    showWorkflowDialog (item) {
      this.viewWorkflow = Object.assign({}, item)
      if (this.viewWorkflow.substitutes === null) {
        this.viewWorkflow.substitutes = {
          user: {
            name: this.$t('workflow.noSubstitute')
          }
        }
      }
      this.viewWorkflowDialog = true
    },
    chooseApprover (item) {
      const userDefault = this.getApproverDefault()
      const itemApprover = item.items.find(item => item.is_first_step === 1)
      this.chooseApproverDialog = true
      this.editApprover = Object.assign({}, itemApprover)
      this.editApprover.gst_approver_id = this.editApprover.gst_approver_id == null ? userDefault : this.editApprover.gst_approver_id
    },
    saveItem () {
      if (this.$refs.formItem.validate()) {
        if (this.validExist === true) {
          this.showNotification(this.$t('workflow.validatorExist'), 'error', -1)
        } else {
          this.editedItem.gst_area = this.workflow.gst_area_id
          this.loading = true
          this.disabled = true
          this.save()
        }
      }
    },
    continueSave () {
      this.editedItem.gst_area = this.workflow.gst_area_id
      this.loading = true
      this.disabled = true
      this.save()
    },
    saveWorkflow () {
      if (this.$refs.formWorkflow.validate()) {
        if (this.validExist === true) {
          this.showNotification(this.$t('workflow.validatorExist'), 'error', -1)
        } else {
          this.loading = true
          this.disabled = true
          this.save()
        }
      }
    },
    continueSaveW () {
      this.loading = true
      this.disabled = true
      this.save()
    },
    saveEditedItem () {
      if (this.$refs.formEditItem.validate()) {
        this.loading = true
        this.disabled = true
        this.$emit('putItem', {item: this.editedViewItem, context: this})
      }
    },
    updateApprover () {
      if (this.$refs.formEditApprover.validate()) {
        this.loading = true
        this.disabled = true
        this.$emit('putItem', {item: this.editApprover, context: this})
      }
    },
    removeItem (item) {
      this.removedItem = item
      this.removeDialog = true
    },
    remove (item) {
      this.loading = true
      const index = this.workflows.indexOf(item)
      this.$emit('deleteItem', {id: item.id, item: item, index: index, context: this})
    },
    save () {
      this.$emit('postItem', {item: this.editedItem, context: this})
    },
    changePlace () {
      if (this.$refs.formPlace.validate()) {
        this.$emit('changePlace', {from: this.editedPlaceItem.id, to: this.editedPlaceItem.to, context: this})
      }
    },
    refresh  () {
      this.getWorkflows()
    },
    getApproverDefault () {
      return this.filterApprovers.find(objeto => objeto.is_default === 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/workflow.component.vue